import { CatalogEnvService } from '@aipb/gulliver/catalog/env';
import { CustomRecordItem } from '@aipb/gulliver/catalog/model';
import { isDropbox } from '@aipb/gulliver/catalog/util';
import { DropboxRepository } from '@aipb/gulliver/dropbox/data-access';
import { Directive, inject, Input } from '@angular/core';
import { MultiImageDownloadRepository } from '@aipb/gulliver/catalog/data-access';

@Directive()
export class ResultListItemBase {
  @Input() coreId: string;
  @Input() item: CustomRecordItem;
  @Input() active: boolean;
  @Input() opened: boolean;
  @Input({
    required: true
  })
  index: number;
  @Input({
    required: true
  })
  searchId: string;

  protected catalogEnv = inject(CatalogEnvService);
  protected dropboxRepository = inject(DropboxRepository);
  protected multiImageDownloadRepository = inject(MultiImageDownloadRepository);

  multiImageDownloadActive$ = this.multiImageDownloadRepository.active$;

  isDropbox(item: CustomRecordItem): boolean {
    return isDropbox(item.GulliverRecType);
  }

  getImageUrl(item: CustomRecordItem): string {
    let image = item.header.images.length > 0 ? item.header.images[0].thumb || item.header.images[0].large : null;
    if (this.isDropbox(item)) {
      image = this.dropboxRepository.getImage(item[this.catalogEnv.env.castor.UUID]);
      return 'data:image/png;base64,' + image;
    }

    return image;
  }
}
